import { setTaskLockStatus } from '@dispatch/shared/services';
import {
  TaskLockStatus,
  TaskStatusRequest,
  TaskResponse,
} from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

type LockStatusMudationData = {
  status: TaskLockStatus;
  taskId: string;
  request?: TaskStatusRequest;
};

export function useSetTaskLockStatus(
  onSuccess?: () => void,
  onError?: () => void
) {
  const queryClient = useQueryClient();
  const setLockedStatusMutation = useMutation(
    async (data: LockStatusMudationData) =>
      setTaskLockStatus(data.taskId, data.status, data.request),
    {
      onSuccess,
      onError,
      onSettled: (_data, _error, variables) => {
        queryClient.invalidateQueries(['task', variables.taskId]);
        queryClient.invalidateQueries(['taskEvents']);
        queryClient.invalidateQueries(['summaries']);
        queryClient.invalidateQueries(['schedule-data-infinite']);
      },
    }
  );
  const setLockStatusInCache = (taskId?: string) => {
    const task = queryClient.getQueryData<TaskResponse>(['task', taskId]);
    if (task) {
      task.$msg.lockedAt = task.$msg.lockedAt
        ? undefined
        : new Date().toISOString();
    }
    queryClient.setQueryData(['task', taskId], task);
  };

  const invalidateLockStatus = (taskId?: string) => {
    queryClient.invalidateQueries(['task', taskId]);
    queryClient.invalidateQueries(['taskEvents']);
    queryClient.invalidateQueries(['schedule-data']);
    queryClient.invalidateQueries(['schedule-data-infinite']);
  };

  return {
    setLockedStatusMutation,
    setLockStatusInCache,
    invalidateLockStatus,
  };
}
